import { defineComponent as _defineComponent } from 'vue';
import NavLink from "./NavLink.vue";
import ResponsiveNavLink from "./ResponsiveNavLink.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'AdministratorMenuLinks',
    props: {
        responsive: {
            type: Boolean,
            default: false,
        },
    },
    setup(__props, { expose }) {
        expose();
        const props = __props;
        const navLinkComponent = props.responsive ? ResponsiveNavLink : NavLink;
        const __returned__ = { props, navLinkComponent };
        Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true });
        return __returned__;
    }
});
